import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ConstElement from '../common/ConstElement';

export default class DetailChat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chat: {},
        }
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        if (this.props.match.params.hasOwnProperty('id')) {
            //View detail mail
            const chatId = this.props.match.params.id;
            axios.get('/api/chats/' + chatId).then(response => {
                this.setData(response.data);
            });
        }
    }

    /**
     * Set data of chat
     * data: Object Chat
     */
    setData(data) {
        this.setState({
            chat: data
        })
    }

    /**
     * Get data of mail
     */
    getData() {
        return this.state.chat;
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/chats">チャット履歴</a></li>
                                <li className="breadcrumb-item active" aria-current="page">チャット詳細</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                            <div className="card mb-3">
                                <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">チャット詳細</h4></div>
                                    <div className="card-body">
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">送信日</label>
                                            <div className="col-sm-8">
                                                <span className="col-value text-left">{this.state.chat.created_at}</span>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">送信者</label>
                                            <div className="col-sm-8">
                                                <a className="col-value text-left text-primary" href={this.state.chat.client_client_id ? "/accounts/edit/" + this.state.chat.client_client_id : ''}>{this.state.chat.client_first_last_name}</a>
                                                {/* <span className="col-value text-left">{this.state.message.categories_name}</span> */}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">受信者</label>
                                            <div className="col-sm-8">
                                                <a className="col-value text-left text-primary" href={this.state.chat.worker_client_id ? "/accounts/edit/" + this.state.chat.worker_client_id : ''}>{this.state.chat.worker_first_last_name}</a>
                                                {/* <span className="col-value text-left">{this.state.message.categories_name}</span> */}
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">チケットID</label>
                                            <div className="col-sm-8">
                                                <a className="col-value text-left text-primary" href={this.state.chat.ticket_id ? "/tickets/edit/" + this.state.chat.ticket_id : ''}>{this.state.chat.ticket_id}</a>
                                                {/* <a className="text-primary" href={this.props.data.ticket_id ? "/tickets/edit/" + this.props.data.ticket_id : ''}>{this.props.data[item.name]}</a> */}

                                                {/* <span className="col-value text-left">{this.state.message.categories_name}</span> */}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">内容</label>
                                            <div className="col-sm-8">
                                                <span className="col-value text-left">{this.state.chat.message}</span>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">内容（マスク処理前）</label>
                                            <div className="col-sm-8">
                                                <span className="col-value text-left">{this.state.chat.message_without_mask}</span>
                                            </div>
                                        </div>
                                    { this.state.chat.image_file_name ?
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">添付画像</label>
                                            <div className="col-sm-8">
                                                <img src={this.state.chat.image_url} width="200" height="200" className="imagePreview img-thumbnail ml-1 mr-1 mb-2" />
                                            </div>
                                        </div>
                                    : '' }
                                    { this.state.chat.pdf_file_name ?
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">添付PDF</label>
                                            <div className="col-sm-8">
                                                <a className="col-value text-left text-primary" href={this.state.chat.pdf_url} target="_blank">{this.state.chat.pdf_file_name}</a>
                                            </div>
                                        </div>
                                    : '' }
                                    </div>
                                <div className="card-footer text-center">
                                    <a onClick={this.handleRedirect} href="/chats" className="btn btn-primary btn-radius btn-lg"><span className="size-inherit">戻る</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        )
    }
}
